import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {
    Card,
    Alert,
    Button,
    Descriptions,
    Space,
    Tag,
    Typography
} from "antd";

import {

    CheckCircleOutlined,
    WalletOutlined,
    TruckOutlined

} from "@ant-design/icons";

const { Title } = Typography;

const ConversationAgreementPanel = ({

                                        agreement,
                                        onInitiatePayment,
                                        onTrackDelivery

                                    }) => {

    const { symbol } = useCurrency();

    if (!agreement) {

        return null;

    }

    return (

        <Card

            bordered={false}

            style={{

                margin:20,

                borderRadius:12,

                background:"#fffbe6"

            }}

        >

            <Space

                direction="vertical"

                style={{

                    width:"100%"

                }}

            >

                <Title level={5}>

                    Accord commercial

                </Title>

                <Alert

                    type="success"

                    showIcon

                    icon={<CheckCircleOutlined />}

                    message="Le vendeur et l'acheteur sont parvenus à un accord."

                />

                <Descriptions

                    bordered

                    size="small"

                    column={1}

                >

                    <Descriptions.Item label="Prix accepté">

                        {agreement.unitPrice} {symbol(agreement.currency)}

                    </Descriptions.Item>

                    <Descriptions.Item label="Quantité / paquet">

                        {agreement.packetQuantity} Kg

                    </Descriptions.Item>

                    <Descriptions.Item label="Nombre de paquets">

                        {agreement.selectedPackets}

                    </Descriptions.Item>

                    <Descriptions.Item label="Montant">

                        <strong>

                            {agreement.totalAmount} {symbol(agreement.currency)}

                        </strong>

                    </Descriptions.Item>

                    <Descriptions.Item label="Statut">

                        <Tag color="green">

                            {agreement.status}

                        </Tag>

                    </Descriptions.Item>

                </Descriptions>

                {

                    agreement.status==="PAYMENT_PENDING" &&

                    <Button

                        type="primary"

                        icon={<WalletOutlined />}

                        block

                        onClick={onInitiatePayment}

                    >

                        Ouvrir le paiement

                    </Button>

                }

                {

                    agreement.status==="DELIVERY_PENDING" &&

                    <Button

                        icon={<TruckOutlined />}

                        block

                        onClick={onTrackDelivery}

                    >

                        Suivre la livraison

                    </Button>

                }

            </Space>

        </Card>

    );

};

export default ConversationAgreementPanel;